import * as React from "react";
import {
  DropDownList,
  DropDownListChangeEvent,
} from "@progress/kendo-react-dropdowns";
import { GridCellProps } from "@progress/kendo-react-grid";
import * as CONSTANTS from "../../utils/CONSTANTS";
import { checkAvailability, checkFunctionality, checkPriority, getMilliSec } from "../../utils/EllowUtils";
import { updateAllocationPosition, updateAllocationResource, updateAvailablity, updatePriority } from "./services";
import classnames from "classnames";
import { RESOURCEPOSITIONS } from "../../navigation/CONSTANTS";
import mixpanelData, { userProfile } from "../../utils/mixpanel";

export const AllocatedDropdown = (props: GridCellProps, getTableValues: any) => {
  
  const userLoginId = localStorage.getItem('loginId')
  const { dataItem } = props;
  const field = props.field || '';
  
  const dataValue = dataItem[field] === null ? '' : dataItem[field];

  const selectDropdown = () => {
   
    let allocation = dataItem && dataItem.allocatedTo && dataItem.allocatedTo.map((item: any, key: number) => {
      return (
        {
          text: item.name,
          value: item.id
        }
      )
    })
    
    
    return allocation
  }

  const handleChange = (e: DropDownListChangeEvent) => {
          
    if (field === 'allocated_to') {
     
      let value = {
        "userLoginId": userLoginId,
        "jobId": props && props.dataItem.jobId,
        "allocatedTo":  e.target.value.value
      } 
      
      updateAllocationPosition(value).then((response) => {
        if (response && response.status === 1) {            
          mixpanelData('TG-Position Allocated to Updated', {
            'source': "Recruiter changed the allocation",
            'allocatedTo': e.target.value.text,
            'positionName': props.dataItem.positionName,
            'Recruiter email': localStorage.getItem('Email'),
            'distinct_id': localStorage.getItem('Email'),
            'company': props.dataItem.company,
            "jobId": props && props.dataItem.jobId,
            "allocated to email": response?.data[0]?.allocatedToEmail,
            "Job Role": props.dataItem.job_role && props.dataItem.job_role.name,
            "Active position" : props.dataItem.positionCount
          }) 
          mixpanelData('New TG - Position Allocated to Updated', {
            'Source': "Recruiter changed the allocation",
            'distinct_id': localStorage.getItem('Email'),
            'Recruiter email': localStorage.getItem('Email'),
            'Position name': props.dataItem.positionName,
            "Jobrole": props.dataItem.job_role && props.dataItem.job_role.name,
            "JobId": props && props.dataItem.jobId,
            'Company name': props.dataItem.company,
            'Allocated To': e.target.value.text,
            "Active position" : props.dataItem.positionCount,
            'Type of job': response && response.data[0].jobType
          })        
          getTableValues();
        }
      })
    }
    
    if (field === 'allocatedTo') {

        let value = {
          "userLoginId":userLoginId,
          "loginId": props && props.dataItem.loginId,
          "allocatedTo": e.target.value.value
        
        }
        
      updateAllocationResource(value).then((response) => {
        if (response && response.status ===  1) {          
          mixpanelData('TG-Resource Allocated-to Updated', {
            'source': "Recruiter changed the allocation",
            'allocatedTo': e.target.value.text,
            'Candidate Name': props?.dataItem?.data?.name,
            'email': localStorage.getItem('Email'),
            'distinct_id': localStorage.getItem('Email'),
            "allocated to email": response?.data[0]?.allocatedToEmail
          }) 
          mixpanelData('New TG - Resource Allocation', {
            'source': "Recruiter changed the allocation",
            'Allocated to': e.target.value.text,
            'Candidate name': response.data.name,
            'Candidate email': localStorage.getItem('Email'),
            'distinct_id': localStorage.getItem('Email'),
            'Candidate loginid': props.dataItem.loginId,
          })  
          userProfile({
            'Allocated to': e.target.value.text,
          }, props.dataItem.loginId)
          setTimeout(() => {
            getTableValues(); 
          }, 1000);
        }
        })
      }     
      

    if (props.onChange && field !== 'allocatedTo') {
      props.onChange({
        dataIndex: 0,
        dataItem: props.dataItem,
        field: props.field,
        syntheticEvent: e.syntheticEvent,
        value: e.target.value.value,
      });
    }


  };


 
  
    return (
      <td>
        { dataItem && dataItem.inEdit ? (
          <DropDownList
            style={{ width: "100%" }}
            onChange={handleChange}
            value={selectDropdown() && selectDropdown().find((c: { value: any; }) => c.value === dataValue)}
            data={selectDropdown()}
            textField='text'
            dataItemKey='value'
                />
        ) : (
            
               dataValue
            
          )
          }
      </td>
    );
}
